import { create } from 'zustand';

import { DiscoveryStatus } from '@/types/discovery.status.type';
import { FeatureLocks } from '@/types/feature.locks.type';
import { Stage } from '@/types/stage.type';

export interface StageState {
  stageList: Array<Stage> | [];
  featureLocks: FeatureLocks | undefined;
  discoveryStatus: DiscoveryStatus | undefined;
  isDataLoaded: boolean;
  isDataLoading: boolean;
  getStageList: () => Array<Stage> | [];
  setStageList: (lists: Array<Stage> | []) => void;
  getFeatureLocks: () => FeatureLocks | undefined;
  setFeatureLocks: (locks: FeatureLocks) => void;
  getDiscoveryStatus: () => DiscoveryStatus | undefined;
  setDiscoveryStatus: (status: DiscoveryStatus | undefined) => void;
  setDataLoading: (loading: boolean) => void;
  setDataLoaded: (loaded: boolean) => void;
}

const useStageStore = create<StageState>((set, get) => ({
  stageList: [],
  featureLocks: undefined,
  discoveryStatus: undefined,
  isDataLoaded: false,
  isDataLoading: false,
  getStageList: () => get().stageList,
  setStageList: (lists: Array<Stage> | []) => set(() => ({ stageList: lists })),
  getFeatureLocks: () => get().featureLocks,
  setFeatureLocks: (locks: FeatureLocks) =>
    set(() => ({ featureLocks: locks })),
  getDiscoveryStatus: () => get().discoveryStatus,
  setDiscoveryStatus: (status: DiscoveryStatus | undefined) =>
    set(() => ({ discoveryStatus: status })),
  setDataLoading: (loading: boolean) => set(() => ({ isDataLoading: loading })),
  setDataLoaded: (loaded: boolean) => set(() => ({ isDataLoaded: loaded })),
}));

export { useStageStore };
